export default __webpack_public_path__ + "static/media/login.103b30a1.svg";